<template>
    <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Filter</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar>
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Filter</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="fliter-content-sec ion-padding">
      <div class="filter-form-wrapper">
        <ion-grid>
          <ion-row>
            <ion-col size-md="4" size-xl="3" size-xs="12">
              <div class="selectBox">
                <ion-label>Charger Type</ion-label>
                <!-- <span class="custom-select-placeholder" v-if="chargerTypePlaceholder">Select</span> -->
                <ion-select placeholder="Select Charger Type"
                  class="form-select"
                    @ionChange="chargerType($event.detail.value)"
                    :value="chargerTypesSelectedValue"
                    :key="chargerTypeKey"
                  >
                  <ion-select-option
                    v-for="list in chargerTypes"
                    :key="list.id"
                    :selected="list.id==chargerTypesSelectedValue"
                    :value="list.id"
                  >{{ getTitle(list.name) }}</ion-select-option>
                </ion-select>
                <!-- <span class="custom-select-icon">
                  <img src="/../assets/images/common/dropdown/118738.png" />
                </span> -->
              </div>
            </ion-col>
            <ion-col size-md="4" size-xl="3" size-xs="12" v-show="disableSelect">
              <div class="selectBox">
                <ion-label>Charger Output</ion-label>
                <!-- <span class="custom-select-placeholder" v-if="chargerOutputPlaceholder">Select</span> -->
                <ion-select placeholder="Select Charger Output"
                  @ionChange="chargerOutput($event.detail.value)"
                  :value="chargerOutputSelectedValue"
                  :key="chargerOutputKey"
                >
                  <ion-select-option
                    v-for="list in chargerOutputs"
                    :key="list.id"
                    :selected="list.id==chargerOutputSelectedValue"
                    v-bind:value="list.id"
                  >{{ getTitle(list.name) }}</ion-select-option>
                </ion-select>
                <!-- <span class="custom-select-icon">
                  <img src="/../assets/images/common/dropdown/118738.png" />
                </span> -->
              </div>
            </ion-col>
            <ion-col size-md="4" size-xl="3" size-xs="12">
              <ion-radio-group
                class="chargerPortRB"
                @ionChange="chargerPort($event.detail.value)"
                v-if="chargerPortRB"
                :value="chargerPortSelectedValue"
              >
                <ion-label class="chargerPortRB-title">Charger Port</ion-label>
                <ion-item v-for="list in chargerPorts" :key="list.id">
                  <img :src="list.image" class="radio-btn-img" />
                  <ion-label text-wrap>{{ list.name }}</ion-label>
                  <ion-radio
                    v-slot: end
                    :checked="list.id==chargerPortSelectedValue"
                    v-bind:value="list.id"
                  ></ion-radio>
                </ion-item>
              </ion-radio-group>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="btn-wrapper rp-desktop">
        <ion-button class="btn-reset" expand="block" v-on:click="resetForm">Clear</ion-button>
        <!-- <ion-button class="btn-apply" expand="block" v-on:click="saveFilter" :disabled='EVChargerOutputPortType == null'>Apply</ion-button> -->
        <ion-button class="btn-apply" expand="block" v-on:click="saveFilter" :disabled='displayApplyBtn'>Apply</ion-button>
      </div>
    </ion-content>
    <ion-footer>
      <div class="btn-wrapper rp-mobile">
        <ion-button class="btn-reset" v-on:click="resetForm" expand="block">Clear</ion-button>
        <!-- <ion-button class="btn-apply" v-on:click="saveFilter" expand="block" :disabled='EVChargerOutputPortType == null'>Apply</ion-button> -->
        <ion-button class="btn-apply" v-on:click="saveFilter" expand="block" :disabled='displayApplyBtn'>Apply</ion-button>
      </div>
    </ion-footer>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonRadioGroup, IonItem, IonRadio, IonButton, IonFooter } from "@ionic/vue";

import { Coordiate } from "@/entity/location/corodinate";
import { EVCStationService } from "@/service/evcstation/stations.service";
import { LocalStorage } from "../../data/localstorage";
import { EVChargerService } from "@/service/evcstation/charger.service";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
  name: 'reservationFilter',
  components: {
    IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonRadioGroup, IonItem, IonRadio, IonButton, IonFooter
  },
  data() {
    return {
      chargerTypes: [],
      chargerOutputs: [],
      chargerPorts: [],
      chargerOutputKey: 0,
      chargerPortKey: 0,
      chargerOutputPlaceholder: true,
      chargerPortPlaceholder: true,
      chargerTypePlaceholder: true,
      chargerTypeKey: 0,
      EVChargerType: null,
      EVChargerOutputType: null,
      EVChargerOutputPortType: null,
      chargerTypesSelectedValue: null,
      chargerOutputSelectedValue: null,
      chargerPortSelectedValue: null,
      loadFilterTag: false,
      chargerPortRB: false,
      disableSelect: false,
      displayApplyBtn: true
    }
  },
  mounted() {
    this.filterList();
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    filterList() {
      let chargerTypes = new EVChargerService()
        .chargerTypesForReservation()
        .then((data) => {
          this.chargerTypes = data;
          this.loadFilter();
        }).catch((error) => {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });
    },
    getTitle(title) {
      let cusTitle = title.split("-")[0];
      return cusTitle;
    },
    loadFilter() {
      let loadFilter = new EVCStationService()
        .recentlySelectedFilterCriteriaForUser(new LocalStorage().user)
        .then((loadFilterdata) => {
          // 2.0 migration start
          // this.chargerTypesSelectedValue = loadFilterdata.chargerType.id;
          // this.chargerOutputSelectedValue = loadFilterdata.outputType.id;
          // this.chargerPortSelectedValue = loadFilterdata.portType.id;
          // this.loadFilterTag = true;
          // 2.0 migration end
          this.chargerType(loadFilterdata.chargerType.id);
          this.chargerOutput(loadFilterdata.outputType.id);
          this.chargerPort(loadFilterdata.portType.id);
        }).catch((error) => {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });
    },
    saveFilter() {
      
      //*********************Changes Start*******************************************
      //* Rel 2.1             Vinoth                9th Apr 2025                  *
      //*****************************************************************************
      // Here we restricting add filter in database, so here we are using local storage. 
      // let SaveFilter = new EVCStationService()
      //   .saveSelectedChargerTypeOutputPortForUser(
      //     this.EVChargerType,
      //     this.EVChargerOutputType,
      //     this.EVChargerOutputPortType,
      //     new LocalStorage().user
      //   )
      //   .then((data) => {
      //     this.$router.push("/customer/reservation");
      //   }).catch((error) => {
      //       let serviceError = migratedTryParseServiceError(error);
      //       new ToastUtils().presentToast(serviceError.description);
      //   });
      //*********************Changes End*******************************************
      //* Rel 2.1             Vinoth                9th Apr 2025                  *
      //*****************************************************************************
        let preferenceInfo = {
          chargerType: {
              code: this.EVChargerType.id
          },
          // chargerOutput: {
          //     code: this.EVChargerOutputType.id
          // },
          // chargerPort: {
          //     code: this.EVChargerOutputPortType.id
          // }
      }
      localStorage.setItem('userFilterData', JSON.stringify(preferenceInfo)) ;
      this.$router.push("/customer/reservation");
    },
    chargerType(event) {
      this.EVChargerOutputPortType = null;
      this.EVChargerOutputPortType = null;
      var chargerOutputs = this.chargerTypes.filter((data) => {
        this.chargerTypesSelectedValue = event;
        return data.id == event;
      });
      this.EVChargerType = chargerOutputs[0];
      this.chargerOutputs =
        chargerOutputs.length > 0 ? chargerOutputs[0].outputTypes : "";
      this.chargerOutputKey += 1;
      this.chargerPortKey += 1;
      this.chargerTypePlaceholder = chargerOutputs.length > 0 ? false : true;
      this.chargerOutputPlaceholder = true;
      this.chargerPortRB = false;
      this.chargerPortPlaceholder = true;
      this.chargerPorts = [];
      if (this.loadFilterTag == false) {
        this.chargerOutputSelectedValue = null;
      }
      if (this.chargerOutputs.length > 0) {
        this.displayApplyBtn = false;
        // Below code commeted for here only filter based on charger type so we no need output
        // this.disableSelect = true;
      }
    },
    chargerOutput(event) {
      this.EVChargerOutputPortType = null;
      if (this.chargerOutputs.length > 0) {
        this.chargerPortRB = true;
        var chargerPorts = this.chargerOutputs.filter((data) => {
          this.chargerOutputSelectedValue = event;
          return data.id == event;
        });
        this.EVChargerOutputType = chargerPorts[0];
        this.chargerPorts = chargerPorts[0].portTypes;
        this.chargerPortKey += 1;
        this.chargerOutputPlaceholder = false;
        this.chargerPortPlaceholder = true;
        if (this.loadFilterTag == false) {
          this.chargerPortSelectedValue = null;
        }
        this.loadFilterTag = false;
      }
    },
    chargerPort(event) {
      if (this.chargerPorts.length > 0) {
        this.chargerPortPlaceholder = false;
        var chargerPortsUpdate = this.chargerPorts.filter((data) => {
          this.chargerPortSelectedValue = event;
          return data.id == event;
        });
        this.EVChargerOutputPortType = chargerPortsUpdate[0];
      }
    },
    resetForm() {
      this.chargerPortKey += 1;
      this.chargerOutputKey += 1;
      this.chargerTypeKey += 1;
      (this.chargerOutputPlaceholder = true),
        (this.chargerPortPlaceholder = true),
        (this.chargerTypePlaceholder = true),
        (this.chargerPortSelectedValue = null);
      this.chargerOutputSelectedValue = null;
      this.chargerTypesSelectedValue = null;
      this.chargerPorts = [];
      this.chargerOutputs = [];
      this.loadFilterTag = false;
      this.chargerPortRB = false;
      this.disableSelect = false;
      new EVCStationService()
        .clearSelectedChargerTypeOutputPortForUser(new LocalStorage().user)
        .then((data) => {
          // Below code is commented by vinoth on 10.02.2022 becuase need to reload current page
          // this.$router.push("/customer/reservationFilter");
          this.EVChargerOutputPortType = null;
          this.EVChargerOutputPortType = null;
        }).catch((error) => {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });
    }
  }
})
</script>

<style scoped>
.fliter-content-sec {
  --background: #f4f5f9;
}
.radio-btn-img {
  width: 44px;
  height: 44px;
  margin-right: 15px;
}
.custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 16px;
  background: #fff;
  right: 15px;
}
.filter-form-wrapper {
  min-height: 100px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  opacity: 1;
  margin-top: 9px;
  margin-bottom: 15px;
  padding: 17px 19px 18px 19px;
}
.chargerPortRB ion-label.chargerPortRB-title {
  position: relative;
  top: -7px;
}
.selectBox {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.selectBox ion-select {
  max-width: 317px;
  width: 100%;
  height: 52px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 12px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.selectBox ion-label {
  position: absolute;
  z-index: 99;
  top: -8px;
  background: #fff;
  padding: 0px 4px;
  left: 18px;
}

.selectBox .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.btn-wrapper .btn-reset,
.btn-wrapper .btn-apply {
  width: 216px;
  height: 52px;
  border-radius: 56px;
  opacity: 1;
  font-size: 17px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #ffffff;
  text-transform: capitalize;
  display: inline-block;
}

.btn-wrapper .btn-reset {
  --background: #041648;
}

.btn-wrapper.rp-desktop .btn-reset {
  margin-left: 23px;
  margin-right: 19px;
}

.btn-wrapper .btn-apply {
  --background: #21b24b;
}

.btn-wrapper.rp-mobile .btn-reset,
.btn-wrapper.rp-mobile .btn-apply {
  height: 52px;
  opacity: 1;
  font-size: 17px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #ffffff;
  text-transform: uppercase;
  display: table-cell;
  --border-radius: 0px;
  padding: 0px;
}

@media (max-width: 768px) {
  .filter-form-wrapper {
    height: 96%;
  }
  .chargerPortRB ion-item {
    --padding-start: 0;
  }
  .selectBox {
    margin-bottom: 18px;
  }

  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #fff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>